import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { TOKEN_INFO } from '@core/constants/generic.constant';
import { AUTHPATHS } from '@core/enums/paths.enum';
import Cookies from 'js-cookie';

interface AuthProtectedProps {
    children: ReactNode;
}

const AuthProtected: React.FC<AuthProtectedProps> = ({ children }) => {
    if (!Cookies.get(TOKEN_INFO)) {
        return <Navigate to={{ pathname: AUTHPATHS.Login }} />;
    }
    return <React.Fragment>{children}</React.Fragment>;
};

export default AuthProtected;
